var map = {
	"./qingsu-poster-level-1.png": "bea2",
	"./qingsu-poster-level-2.png": "2a0e",
	"./qingsu-poster-level-3.png": "2822",
	"./qingsu-poster-level-4.png": "66dc",
	"./qingsu-poster-level-5.png": "1e41"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9de8";